import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingScreen from './LoadingScreen';

// 🔐 Protected Route Component
// Ensures user is authenticated before accessing protected routes
// Redirects to login if user is not authenticated or session has expired

const ProtectedRoute = ({ children, user, isAuthReady }) => {
  const location = useLocation();

  // If auth is not ready yet, show loading
  if (!isAuthReady) {
    return (
      <LoadingScreen
        message="Checking authentication..."
        subMessage="Securing your session"
        fullScreen
      />
    );
  }

  // Simple authentication check - only check if user exists
  const isAuthenticated = user && user.uid;

  // If user is not authenticated, redirect to login
  if (!isAuthenticated) {
    console.log('🔒 Access denied - no authenticated user, redirecting to login', {
      currentPath: location.pathname,
      user: user ? 'exists but no uid' : 'null'
    });
    
    // Redirect to login with the attempted path as a query parameter
    const redirectPath = location.pathname !== '/' ? location.pathname : '/dashboard';
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirectPath)}`} replace />;
  }

  // User is authenticated and session is valid, render the protected component
  return children;
};

export default ProtectedRoute;
